module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "dropdown messages-menu"
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "javascript:;",
      "data-toggle": "dropdown"
    }
  }, [_c('i', {
    staticClass: "fa fa-envelope-o"
  }), _vm._v(" "), _c('span', {
    staticClass: "label label-success"
  }, [_vm._v(_vm._s(_vm._f("count")(_vm.userInfo.messages)))])]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', {
    staticClass: "header"
  }, [_vm._v("You have " + _vm._s(_vm._f("count")(_vm.userInfo.messages)) + " message(s)")]), _vm._v(" "), (_vm.userInfo.messages.length > 0) ? _c('li', [_c('ul', {
    staticClass: "menu"
  }, _vm._l((_vm.userInfo.messages), function(message) {
    return _c('message-item', {
      key: message.id,
      attrs: {
        "message": message
      }
    })
  }))]) : _vm._e(), _vm._v(" "), (_vm.userInfo.messages.length > 0) ? _c('li', {
    staticClass: "footer"
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("See All Messages")])]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0b8e8ad9"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/MessagesMenu.vue
// module id = 1540
// module chunks = 1